import { createFileRoute } from "@tanstack/react-router";
import KuraCalendar from "@/components/kura-calendar";

export const Route = createFileRoute("/_authenticated/calendar")({
  component: CalendarPage,
});

function CalendarPage() {
  return (
    <div className="space-y-6 p-4 md:p-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold tracking-tight">Kura Takvimi</h1>
        <p className="text-muted-foreground">
          Planlanan kuraları aylık takvim görünümünde görüntüleyin ve yönetin
        </p>
      </div>
      
      <KuraCalendar />
    </div>
  );
}